export function uid(): string {
  return Math.random().toString(36).slice(2);
}

export function todayLabel(): string {
  return new Date().toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
